/* --------------------------------------------------------------------------
   Karuzele "Nagrody" i "Partnerzy" — 27.09.2026

   Ten sam mechanizm scroll-snap + strzałki co .recordings (home.js). Jedna
   funkcja, dwa wywołania — Nagrody kroczy po całej szerokości toru (jeden
   award widoczny naraz), Partnerzy tylko o połowę (dwóch partnerów na
   stronę), bo .partner ma flex-basis 50% (assets/content.css), nie 100%
   jak .award.

   Osobny, mały plik zamiast dopisywania do home.js: obie sekcje występują
   też na stronach, które nie ładują home.js (np. O nas dla Nagród).

   28.09.2026: dopisane strzałki dla listy założycieli (.people) na mobile
   (na desktopie to siatka, strzałki ukryte). Tu, a nie w sekcji O nas, bo
   ten plik już się tam ładuje.
   -------------------------------------------------------------------------- */
(function () {
  function wireCarousel(root, trackSelector, prevSelector, nextSelector) {
    const track = root.querySelector(trackSelector);
    const prev = root.querySelector(prevSelector);
    const next = root.querySelector(nextSelector);
    if (!track || !prev || !next) return;

    function update() {
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }

    prev.addEventListener("click", () => {
      track.scrollBy({ left: -track.clientWidth, behavior: "smooth" });
    });
    next.addEventListener("click", () => {
      track.scrollBy({ left: track.clientWidth, behavior: "smooth" });
    });
    track.addEventListener("scroll", () => requestAnimationFrame(update), { passive: true });
    window.addEventListener("resize", update);
    update();
  }

  document.querySelectorAll("[data-awards]").forEach((root) => {
    wireCarousel(root, ".awards-row", "[data-awards-prev]", "[data-awards-next]");
  });

  document.querySelectorAll("[data-partners]").forEach((root) => {
    wireCarousel(root, ".partners-slider-wrapper", "[data-partners-prev]", "[data-partners-next]");
  });

  const lists = document.querySelectorAll(".people");
  if (!lists.length) return;

  const style = document.createElement("style");
  style.textContent = `
    .section__head--nav { display: flex; align-items: center; justify-content: space-between; gap: 1rem; }
    .people-nav { display: none; gap: 0.5rem; flex-shrink: 0; }
    .people-btn {
      width: 2.5rem; height: 2.5rem; display: grid; place-items: center;
      border: 0; border-radius: 50%; padding: 0; background: #fff; cursor: pointer;
      box-shadow: 0 4px 14px rgba(0, 28, 43, 0.14);
      transition: transform 200ms ease, background 200ms ease;
    }
    .people-btn:hover { transform: scale(1.08); background: var(--color-blue); }
    .people-btn:hover svg { stroke: #fff; }
    .people-btn:focus-visible { outline: 2px solid var(--color-blue); outline-offset: 3px; }
    .people-btn:disabled { opacity: 0.3; cursor: default; }
    .people-btn:disabled:hover { transform: none; background: #fff; }
    .people-btn:disabled:hover svg { stroke: var(--color-blue); }
    .people-btn svg {
      width: 14px; height: 24px; fill: none; stroke: var(--color-blue); stroke-width: 3;
      stroke-linecap: round; stroke-linejoin: round; transition: stroke 200ms ease;
    }
    @media (max-width: 700px) {
      .people-nav { display: flex; }
      .people {
        margin-inline: calc(-1 * var(--container-pad));
        padding-inline: var(--container-pad);
        scroll-padding-inline: var(--container-pad);
      }
    }
  `;
  document.head.appendChild(style);

  lists.forEach((list) => {
    const head = list.closest(".container") && list.closest(".container").querySelector(".section__head");
    if (!head) return;
    head.classList.add("section__head--nav");

    const nav = document.createElement("div");
    nav.className = "people-nav";
    nav.innerHTML =
      '<button type="button" class="people-btn" data-people-prev aria-label="Poprzedni założyciel"><svg viewBox="0 0 16 28" aria-hidden="true"><path d="M14 2 2 14l12 12"/></svg></button>' +
      '<button type="button" class="people-btn" data-people-next aria-label="Następny założyciel"><svg viewBox="0 0 16 28" aria-hidden="true"><path d="m2 2 12 12L2 26"/></svg></button>';
    head.appendChild(nav);

    const prev = nav.querySelector("[data-people-prev]");
    const next = nav.querySelector("[data-people-next]");

    function step() {
      const card = list.querySelector(".person");
      return card ? card.getBoundingClientRect().width + 16 : list.clientWidth;
    }

    function update() {
      prev.disabled = list.scrollLeft <= 2;
      next.disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
    }

    prev.addEventListener("click", () => list.scrollBy({ left: -step(), behavior: "smooth" }));
    next.addEventListener("click", () => list.scrollBy({ left: step(), behavior: "smooth" }));
    list.addEventListener("scroll", () => requestAnimationFrame(update), { passive: true });
    window.addEventListener("resize", update);
    update();
  });
})();
